import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation, Trans } from 'react-i18next';

import { isZeroDiscountAndVipSuccess } from '../../../../utils/discountValidation';

import './DiscountMessage.scss';

export class DiscountMessage extends Component {
  static propTypes = {
    data: PropTypes.shape({
      discount: PropTypes.string,
      minNumberOfTickets: PropTypes.number,
      claims: PropTypes.number,
      productNames: PropTypes.array,
      status: PropTypes.string,
      success: PropTypes.bool,
      contactEmail: PropTypes.string,
      contactTelephone: PropTypes.string,
    }),
    appliedCode: PropTypes.string,
  };

  getEnding(quantity) {
    switch (quantity % 10) {
      case 1:
        return quantity + 'st';
      case 2:
        return quantity + 'nd';
      case 3:
        return quantity + 'rd';
      default:
        return quantity + 'th';
    }
  }

  getProductsForMessage(productNames = []) {
    return productNames.join(', ');
  }

  getMessageByType(t, data = {}) {
    const {
      discount,
      minNumberOfTickets,
      status = 'withoutStatus',
      productNames,
      delegateTypesNames,
      claims,
      appliedCode,
      locale,
      contactEmail,
      contactTelephone,
    } = data;

    let title;
    let text;

    switch (status) {
      case 'MSG_FIXED': {
        title = t('event.purchase.multiBuySuccess');
        text = t('event.purchase.multiBuySuccessFixedAmount', {
          0: minNumberOfTickets,
          1: discount,
          2:
            locale === 'en'
              ? this.getEnding(minNumberOfTickets)
              : minNumberOfTickets,
        });

        break;
      }

      case 'MSG_PERCENTAGE': {
        title = t('event.purchase.multiBuySuccess');
        text = t('event.purchase.multiBuySuccessPercentage', {
          0: minNumberOfTickets,
          1: discount,
          2:
            locale === 'en'
              ? this.getEnding(minNumberOfTickets)
              : minNumberOfTickets,
        });

        break;
      }

      case 'APPLIED': {
        title = t('event.purchase.packageDiscount', { 0: discount });
        break;
      }

      case 'VIP_SUCCESS_PERCENTAGE': {
        title = t('event.purchase.vipSuccess', { 0: appliedCode });
        text = t('event.purchase.vipSuccessPercentage', { 0: discount });
        break;
      }

      case 'VIP_SUCCESS_PERCENTAGE_FOR_PRODUCTS': {
        title = t('event.purchase.vipSuccess', { 0: appliedCode });
        text = t('event.purchase.vipSuccessPercentageForProducts', {
          0: discount,
          2: this.getProductsForMessage(productNames),
        });

        break;
      }

      case 'VIP_SUCCESS_FIXED': {
        title = t('event.purchase.vipSuccess', { 0: appliedCode });
        text = t('event.purchase.vipSuccessFixed', { 0: discount });
        break;
      }

      case 'VIP_SUCCESS_FIXED_FOR_PRODUCTS': {
        title = t('event.purchase.vipSuccess', { 0: appliedCode });
        text = t('event.purchase.vipSuccessFixedForProducts', {
          0: discount,
          2: this.getProductsForMessage(productNames),
        });

        break;
      }

      case 'VIP_NOT_ENOUGH_CLAIMS_PERCENTAGE': {
        title = t('event.purchase.vipSuccess', { 0: appliedCode });
        text =
          claims === 1
            ? t('event.purchase.vipNotEnoughClaimsPercentageSingle', {
                1: claims,
                0: discount,
              })
            : t('event.purchase.vipNotEnoughClaimsPercentageMultiple', {
                0: discount,
                1: claims,
              });
        break;
      }

      case 'VIP_NOT_ENOUGH_CLAIMS_PERCENTAGE_FOR_PRODUCTS': {
        title = t('event.purchase.vipSuccess', { 0: appliedCode });
        text = t('event.purchase.vipNotEnoughClaimsPercentageForProducts', {
          0: discount,
          1: this.getProductsForMessage(productNames),
          2: claims,
        });

        break;
      }

      case 'VIP_NOT_ENOUGH_CLAIMS_FIXED': {
        title = t('event.purchase.vipSuccess', { 0: appliedCode });
        text =
          claims === 1
            ? t('event.purchase.vipNotEnoughClaimsFixedAmountSingle', {
                0: discount,
                1: claims,
              })
            : t('event.purchase.vipNotEnoughClaimsFixedAmountMultiple', {
                0: discount,
                1: claims,
              });
        break;
      }

      case 'VIP_NOT_ENOUGH_CLAIMS_FIXED_FOR_PRODUCTS': {
        title = t('event.purchase.vipSuccess', { 0: appliedCode });
        text = t('event.purchase.vipNotEnoughClaimsFixedAmountForProducts', {
          0: discount,
          1: this.getProductsForMessage(productNames),
          2: claims,
        });

        break;
      }

      case 'NO_CODE_EXISTS': {
        title = t('informa.content.validation.PromotionCodeExists.message');
        text = (
          <Trans
            i18nKey="informa.content.validation.PromotionCode.contact"
            values={{
              0: contactTelephone,
              1: contactEmail,
            }}
          >
            <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
          </Trans>
        );

        break;
      }

      case 'CODE_EXPIRED': {
        title = t('informa.content.validation.PromotionCodeExpired.message');
        text = (
          <Trans
            i18nKey="informa.content.validation.PromotionCode.contact"
            values={{
              0: contactTelephone,
              1: contactEmail,
            }}
          >
            <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
          </Trans>
        );

        break;
      }

      case 'MAX_CLAIMS_REACHED': {
        title = t(
          'informa.content.validation.PromotionMaxClaimsReached.message',
        );
        text = (
          <Trans
            i18nKey="informa.content.validation.PromotionCode.contact"
            values={{
              0: contactTelephone,
              1: contactEmail,
            }}
          >
            <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
          </Trans>
        );

        break;
      }

      case 'CODE_IS_AVAILABLE_ONLY_FOR_PRODUCTS': {
        title = t(
          'informa.content.validation.PromotionCode.onlyAvailableForProducts',
          {
            0: this.getProductsForMessage(productNames),
          },
        );
        text = (
          <Trans
            i18nKey="informa.content.validation.PromotionCode.contact"
            values={{
              0: contactTelephone,
              1: contactEmail,
            }}
          >
            <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
          </Trans>
        );

        break;
      }

      case 'CODE_IS_AVAILABLE_ONLY_FOR_DELEGATE_TYPES': {
        title = t(
          'informa.content.validation.PromotionCode.onlyAvailableForDelegateTypes',
          {
            0: delegateTypesNames?.join(', '),
          },
        );
        text = (
          <Trans
            i18nKey="informa.content.validation.PromotionCode.contact"
            values={{
              0: contactTelephone,
              1: contactEmail,
            }}
          >
            <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
          </Trans>
        );
        break;
      }

      case 'CODE_IS_AVAILABLE_ONLY_FOR_DELEGATE_TYPES_AND_FOR_PRODUCTS': {
        title = t(
          'informa.content.validation.PromotionCode.onlyAvailableForDelegateTypesAndProducts',
          {
            0: delegateTypesNames?.join(', '),
            1: productNames?.join(', '),
          },
        );
        text = (
          <Trans
            i18nKey="informa.content.validation.PromotionCode.contact"
            values={{
              0: contactTelephone,
              1: contactEmail,
            }}
          >
            <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
          </Trans>
        );
        break;
      }

      case 'VIP_SUCCESS_FIXED_FOR_DELEGATE':
      case 'VIP_SUCCESS_PERCENTAGE_FOR_DELEGATE': {
        title = t('site.pricing.discount.vip-code-discount.success.title', {
          0: appliedCode,
        });
        text = t(
          'site.pricing.discount.vip-code-discount.VIP_SUCCESS_FIXED_FOR_DELEGATE-and-VIP_SUCCESS_PERCENTAGE_FOR_DELEGATE.success.message',
          { 0: discount, 1: delegateTypesNames?.join(', ') },
        );
        break;
      }

      case 'VIP_SUCCESS_PERCENTAGE_MULTI_BUY':
      case 'VIP_SUCCESS_FIXED_MULTI_BUY': {
        title = t('site.pricing.discount.vip-code-discount.success.title', {
          0: appliedCode,
        });
        text =
          claims === 1
            ? t(
                'site.pricing.discount.vip-code-discount.VIP_SUCCESS_PERCENTAGE_MULTI_BUY-and-VIP_SUCCESS_FIXED_MULTI_BUY.single-claim.success.message',
                {
                  0: discount,
                  1: claims,
                },
              )
            : t(
                'site.pricing.discount.vip-code-discount.VIP_SUCCESS_PERCENTAGE_MULTI_BUY-and-VIP_SUCCESS_FIXED_MULTI_BUY.multiple-claim.success.message',
                {
                  0: discount,
                  1: claims,
                },
              );
        break;
      }

      case 'withoutStatus': {
        if (discount) {
          title = t('event.purchase.select.vipSuccess.title', { 0: discount });
          text = t('event.purchase.select.vipSuccess.description');
        }

        break;
      }

      default:
        break;
    }

    return { title, text };
  }

  render() {
    const { data, appliedCode, i18n, t } = this.props;
    const { success } = data || {};

    const notification = isZeroDiscountAndVipSuccess(data)
      ? {
          title: t(
            'site.pricing.discount.vip-code-discount.zero-value.accepted.message',
          ),
          text: undefined,
        }
      : this.getMessageByType(t, {
          ...data,
          appliedCode,
          locale: i18n.language,
        });

    return (
      <div className="discount-message">
        <div className="discount-message__container">
          <div
            className={`discount-message__icon ${
              !success ? 'discount-message__icon--error' : ''
            }`}
          >
            <i className="material-icons">
              {success ? 'check_circle' : 'cancel'}
            </i>
          </div>
          <div className="discount-message__text-container">
            <p
              className={`discount-message__title ${
                !success ? 'discount-message__title--error' : ''
              }`}
            >
              {notification.title}
            </p>
            {notification.text && (
              <p className="discount-message__text">{notification.text}</p>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(DiscountMessage);
